import { defineComponent as s, openBlock as o, createElementBlock as a, mergeProps as d, unref as e, renderSlot as i, createElementVNode as l, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, h = { key: 1 }, M = { key: 2 }, f = { key: 3 }, k = { key: 4 }, y = { key: 5 }, w = {
  name: "ScalarIconSmileyMeh"
}, S = /* @__PURE__ */ s({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(m) {
    const Z = m, { bind: A, weight: n } = u(Z);
    return (r, t) => (o(), a("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(A)), [
      i(r.$slots, "default"),
      e(n) === "bold" ? (o(), a("g", g, t[0] || (t[0] = [
        l("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm52-52a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h80A12,12,0,0,1,180,160ZM76,108a16,16,0,1,1,16,16A16,16,0,0,1,76,108Zm104,0a16,16,0,1,1-16-16A16,16,0,0,1,180,108Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (o(), a("g", h, t[1] || (t[1] = [
        l("path", {
          d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-56a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,160ZM80,108a12,12,0,1,1,12,12A12,12,0,0,1,80,108Zm96,0a12,12,0,1,1-12-12A12,12,0,0,1,176,108Z" }, null, -1)
      ]))) : e(n) === "fill" ? (o(), a("g", M, t[2] || (t[2] = [
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm76,72H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm-4-48a12,12,0,1,1,12-12A12,12,0,0,1,164,120Z" }, null, -1)
      ]))) : e(n) === "light" ? (o(), a("g", f, t[3] || (t[3] = [
        l("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm46-58a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h80A6,6,0,0,1,174,160ZM82,108a10,10,0,1,1,10,10A10,10,0,0,1,82,108Zm92,0a10,10,0,1,1-10-10A10,10,0,0,1,174,108Z" }, null, -1)
      ]))) : e(n) === "regular" ? (o(), a("g", k, t[4] || (t[4] = [
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-56a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,160ZM80,108a12,12,0,1,1,12,12A12,12,0,0,1,80,108Zm96,0a12,12,0,1,1-12-12A12,12,0,0,1,176,108Z" }, null, -1)
      ]))) : e(n) === "thin" ? (o(), a("g", y, t[5] || (t[5] = [
        l("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm44-60a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h80A4,4,0,0,1,172,160ZM84,108a8,8,0,1,1,8,8A8,8,0,0,1,84,108Zm88,0a8,8,0,1,1-8-8A8,8,0,0,1,172,108Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  S as default
};
